/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { protectedProfileSchema } from "./protectedProfileSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully updated your profile
 */
export const updateProfile200Schema = protectedProfileSchema

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const updateProfile401Schema = APIErrorSchema

export const updateProfileMutationRequestSchema = z.object({
  bio: z.string(),
  profilePictureType: z
    .enum(["encrypted-image", "public-image"])
    .describe(
      'Type of profile picture - "encrypted-image", "public-image", or empty string for no profile picture',
    )
    .optional(),
  profilePictureURL: z
    .string()
    .describe("URL to the profile picture in blob storage")
    .optional(),
})

export const updateProfileMutationResponseSchema = updateProfile200Schema
